/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://wq9zz9lnkj.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "Emails",
            "endpoint": "https://4bdbdzb4c8.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "Hubspot",
            "endpoint": "https://ds7k4bf5r5.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "Payments",
            "endpoint": "https://2swooav11h.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "TwilioAPI",
            "endpoint": "https://251simeqlc.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2uq65aqtlzhbxe42xxqbaflxvq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-nfn47surererrlxcxfedkhbazu",
    "aws_cognito_identity_pool_id": "us-east-1:8ece2d37-a019-4a8c-8925-816893eff435",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xT2zjeDbC",
    "aws_user_pools_web_client_id": "6ivlo98pmu0pgkelojt4fop7e7",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "rspbucket110446-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
